import { render, staticRenderFns } from "./403.vue?vue&type=template&id=6b2cd38d&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"
import style0 from "./403.vue?vue&type=style&index=0&id=6b2cd38d&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2cd38d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2cd38d')) {
      api.createRecord('6b2cd38d', component.options)
    } else {
      api.reload('6b2cd38d', component.options)
    }
    module.hot.accept("./403.vue?vue&type=template&id=6b2cd38d&scoped=true", function () {
      api.rerender('6b2cd38d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/403.vue"
export default component.exports